import React,{useState} from 'react';
import './pop.css'
import Incbtn from '../../Components/incdec.js'

function LotteryPop(){
    return(
        <>
        <div>
            <div className="lottery-pop-container">
                <div className='lottery-pop-card'>
                    <h3>Number of Tickets?</h3>
                    <p>You're about to buy lottery tickets for Sivaji The Boss by AVM Productions</p>
                    <img />
                    <div className="ticket-count">
                        <div className='incbtn'>
                            <Incbtn />
                        </div>
                        <div>
                            <h6>$340</h6>
                            </div>
                    </div>
                    <button className='ticket-buy-btn'>Buy</button>
                </div>
            </div>
        </div>
        </>
    )
}

export default LotteryPop;